export default class AthenaeumPopupEvents {
  public static closeAthenaeum = 'close-athenaeum';
}
